<script>
  export let digitTitle = undefined;
  export let digitNbre = undefined;
  export let digitText = undefined;
</script>

<!--  carte pour digit -->
{#if digitTitle != undefined}
  <div class="carte digit">
    <div class="carte-body">
      <div class="carte-title">{digitTitle}</div>
      <div class="carte-subtitle" />
      <p class="carte-digit">{digitNbre}</p>
      <div class="carte-texte">
        {#if digitText != undefined}
          {#if typeof digitText === "object"}
            {#each digitText as item}
              {#if typeof item === "object"}
                <p>{item[0]} : {item[1]}</p>
              {/if}
            {/each}
          {:else}
            {digitText}
          {/if}
        {/if}
      </div>
      <slot />
    </div>
  </div>
  {:else}
  card pass => <br>
{/if}

<h2>Card avec slot</h2>
<div class="carte digit">
  <div class="carte-body">
    <div class="carte-title">
      <slot name="title">
        <span class="missing">Unknown name</span>
      </slot>
    </div>
    <div class="carte-subtitle">
      <slot name="subtitle">
        <span class="missing">Unknown address</span>
      </slot>
    </div>
    {#if $$slots.email}
      <div class="carte-texte">
        <slot name="email">
          <span class="missing">Unknown email</span>
        </slot>
      </div>
    {/if}
  </div>
</div>

<style>
  .digit {
    background-color: greenyellow;
  }
  .carte {
    font-size: 0.8em;
    margin-bottom: 8px;
  }
  .carte-title {
    background-color: rgb(117, 174, 32);
    font-size: 1.1em;
    text-align: center;
  }
  .carte-subtitle {
    color: rgb(152, 150, 150);
    font-style: italic;
    text-align: center;
  }
  .carte-digit {
    font-size: 1.5em;
    font-weight: bold;
    background-color: rgb(202, 245, 138);
    text-align: center;
    margin: 0 8px 0 8px;
  }
</style>
